<template>
    <hr>

    <div class="opui-row">
        <div class="opui-col">
            <div class="opui-form-group">
                <label>
                    <a href="#" @click.prevent="toggleFields">
                        {{ $e('Fields') }}
                        <small>({{item.settings.field_map ? item.settings.field_map.length : 0 }} fields)</small>
                    </a>
                </label>

                <div v-if="item.settings.field_map && showFields">
                    <div class="opui-row" v-for="(field, index) in item.settings.field_map">
                        <div class="opui-col">
                            <RichSelect
                                    v-model="field.key"
                                    :options="mentorFields"
                                    :placeholder="'Choose field'"
                            />
                        </div>

                        <FieldMapDynamic :item="item" :field="field" :workflow="workflow" />

                        <div class="opui-col-1">
                            <a href="#" @click.prevent="removeField(index)" class="opui-btn opui-btn-link"><i class="opui-fa opui-fa-trash opui-text-gray-400"></i></a>
                        </div>
                    </div>

                    <div class="opui-row">
                        <div class="opui-col">
                            <a href="#" @click.prevent="addField" class="opui-btn opui-btn-success opui-btn-xs">+ {{ $e('Add new') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RichSelect from "../../Global/RichSelect.vue"
import FieldMapDynamic from "./FieldMapDynamic.vue"

export default {
    components: { FieldMapDynamic, RichSelect },
    props: {
        action:   { type: String, default: 'add' },
        workflow: { type: Object, required: true },
        item:     { type: Object, required: true },
    },
    data() {
        return {
            showFields: false,
        }
    },
    mounted() {
        if (! this.item.settings)           this.item.settings = {}
        if (! this.item.settings.field_map) this.item.settings.field_map = []
    },
    computed: {
        mentorFields() {
            let fields = [
                { id: 'user_id',    text: 'User ID' },
                { id: 'email',      text: 'E-mail' },
            ];

            // Add some fields
            if (this.action === 'add') {
                fields.push({ id: 'first_name', text: 'First Name' })
                fields.push({ id: 'last_name',  text: 'Last Name' })
            }

            return fields
        }
    },
    methods: {
        toggleFields() {
            this.showFields = ! this.showFields
        },

        addField() {
            this.item.settings.field_map.push({
                key:     '',
                value:   '',
            })
        },

        removeField(index) {
            this.item.settings.field_map.splice(index, 1)
        },
    }
}
</script>
